export const ForkConvIcon = () => {
	return (
		<svg
			width="30"
			height="30"
			viewBox="5 5 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.25 8.25V15.9C8.25 17.1601 8.25 17.7902 8.49524 18.2715C8.71095 18.6948 9.05516 19.039 9.47852 19.2548C9.95982 19.5 10.5899 19.5 11.85 19.5H17.25M17.25 19.5C17.25 20.7426 18.2574 21.75 19.5 21.75C20.7426 21.75 21.75 20.7426 21.75 19.5C21.75 18.2574 20.7426 17.25 19.5 17.25C18.2574 17.25 17.25 18.2574 17.25 19.5ZM8.25 12L17.25 12M17.25 12C17.25 13.2426 18.2574 14.25 19.5 14.25C20.7426 14.25 21.75 13.2426 21.75 12C21.75 10.7574 20.7426 9.75 19.5 9.75C18.2574 9.75 17.25 10.7574 17.25 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
